export const config = {
	apiBaseUrl: process.env.REACT_APP_BASE_URL || "/api/",
	publicApiBaseUrl:
		process.env.REACT_APP_PUBLIC_API_BASE_URL ||
		process.env.REACT_APP_BASE_URL ||
		"/api/",
};

export const endpoints = {
	auth: {
		login: "v1/auth/login",
		logout: "v1/auth/logout",
		me: "v1/auth/me",
		password: "v1/auth/password",
	},
	license: {
		list: "v1/license",
		search: "v1/license/search",
		generate: "v1/license/generate",
		catalogs: "v1/license/catalogs",
		uploadSvg: "v1/license/upload-svg",
		license: "v1/license/license",
		public: "v1/license/public",
		publicBySerial: (serial) => `v1/license/public/${serial}`,
		getTemplate: "v1/license/generate/bulk/template",
		uploadFile: "v1/license/generate/bulk",
		updateLicence: (id) => `v1/license/${id}`,
		exportCsv: "v1/license/export/csv",
		updateBulk: "v1/license/update/bulk",
	},
};
